/*
 * @Descripttion:
 * @Author: 凌伟延
 * @Date: 2019-12-03 14:17:56
 */
import instance from './http.config.js'
// let activity_id=window.location
// 获取详情
export const getMaterialDetail = (params, activityId) =>
  instance.get('/player/materials/' + params + '/' + activityId + '?time=' + new Date().getTime())
// // 获取材料要求
export const getMaterialRequired = activityId =>
  instance.get('/player/materials/request/' + activityId)

// 获取上传详情
export const getMaterialDetailV3 = activityId =>
  instance.get(`/v3/player/activities/${activityId}/upload_material`)

// 单个上传保存
export const saveMaterial = (params, userId, activityId) =>
  instance.put('/player/materials/' + userId + '/' + activityId, params)

// 提交按钮
export const submitMaterial = (userId, activityId) =>
  instance.post('/v2/player/materials/' + userId + '/' + activityId + '/finished_material')

// 删除上传的文件
export const deleteMaterial = (playerId, activityId, attachmentId) =>
  instance.delete('/player/materials/' + playerId + '/' + activityId + '/' + attachmentId)

// 上传图片
export const uploadImage = fd =>
  instance.post('/upload/index', fd, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
export const uploadFile = params =>
  instance.post('/upload/oss', params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
export const uploadFileAliYun = params =>
  instance.post(params.host, params.fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: progressEvent => {
      let complete = (((progressEvent.loaded / progressEvent.total) * 100) | 0) + '%'
      console.log(complete)
      self.uploadMessage = '上传 ' + complete
    }
  })
// 删除上传的文件
export const removeUploadFile = url => instance.delete('/upload/oss', url)

// 获取活动详情
export const getActivityDetail = id => instance.get('/v2/admin/activitys/' + id)

// 获取已抽取课件信息
export const getCourseWareDetails = (activityId, playerId) =>
  instance.get('/player/materials/' + playerId + '/' + activityId + '/subject')

// 获取已抽取课件信息
export const getAuditRecord = (playerId, activityId) =>
  instance.get(`/admin/players/${playerId}/activities/${activityId}/material_review_record`)



// WEBPACK FOOTER //
// ./src/service/contestantInfo.js